const COMPONENT_NAME_MULTI_ROW = "costco-ad-set-multi-row";
const DESKTOP_DEFAULT_TILES_PER_ROW = 5;
const TABLET_TILES_PER_ROW_BELOW_THRESHOLD = 4;
const MOBILE_TILES_PER_ROW_BELOW_THRESHOLD = 3;
const TABLET_TILES_PER_ROW_ABOVE_THRESHOLD = 8;
const MOBILE_TILES_PER_ROW_ABOVE_THRESHOLD = 4;
const ITEM_THRESHOLD = 6;
export {
  COMPONENT_NAME_MULTI_ROW,
  DESKTOP_DEFAULT_TILES_PER_ROW,
  ITEM_THRESHOLD,
  MOBILE_TILES_PER_ROW_ABOVE_THRESHOLD,
  MOBILE_TILES_PER_ROW_BELOW_THRESHOLD,
  TABLET_TILES_PER_ROW_ABOVE_THRESHOLD,
  TABLET_TILES_PER_ROW_BELOW_THRESHOLD
};
